import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CommonHeader from '../components/layout/CommonHeader';
import { useLogout } from '../features/auth/hooks/useAuth';

const Settings: React.FC = () => {
  const navigate = useNavigate();
  const { logout, loading: logoutLoading } = useLogout();

  useEffect(() => {
    // Set document title
    document.title = 'Settings - zapOdeon';
  }, []);

  const handleBack = () => {
    // Go back to previous page
    navigate(-1);
  };

  return (
    <div className="h-dvh bg-black text-white overflow-hidden">
      {/* Header */}
      <CommonHeader
        title="Settings"
        onBackClick={handleBack}
      />

      {/* Content Section */}
      <div className="flex-1 bg-black" style={{ padding: '16px', paddingTop: '55px' }}>
        {/* Settings Buttons */}
        <div>
          {/* Support Button */}
          <button 
            onClick={() => {/* TODO: Add support functionality */}}
            className="flex w-full justify-between items-center"
            style={{ 
              padding: '20px',
              background: '#202020',
              color: '#FFF',
              fontFamily: '"Aeonik TRIAL"',
              fontSize: '16px',
              fontWeight: 500,
              lineHeight: '20px',
              letterSpacing: '-0.2px',
              border: 'none',
              borderRadius: '16px',
              marginBottom: '6px'
            }}
          >
            <span>Support</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.1962 9.69184L7.67116 4.33351C7.32533 3.99934 6.66699 4.20184 6.66699 4.64184V15.3585C6.66699 15.7985 7.32533 16.001 7.67116 15.6668L13.1962 10.3085C13.2391 10.2695 13.2735 10.2219 13.2969 10.1688C13.3204 10.1157 13.3326 10.0582 13.3326 10.0002C13.3326 9.94211 13.3204 9.88469 13.2969 9.8316C13.2735 9.7785 13.2391 9.7309 13.1962 9.69184Z" fill="white" fillOpacity="0.56"/>
            </svg>
          </button>

          {/* Terms of Use Button */}
          <button 
            onClick={() => navigate('/terms-of-use')}
            className="flex w-full justify-between items-center"
            style={{ 
              padding: '20px',
              background: '#202020',
              color: '#FFF',
              fontFamily: '"Aeonik TRIAL"',
              fontSize: '16px',
              fontWeight: 500,
              lineHeight: '20px',
              letterSpacing: '-0.2px',
              border: 'none',
              borderRadius: '16px',
              marginBottom: '6px'
            }}
          >
            <span>Terms of Use</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.1962 9.69184L7.67116 4.33351C7.32533 3.99934 6.66699 4.20184 6.66699 4.64184V15.3585C6.66699 15.7985 7.32533 16.001 7.67116 15.6668L13.1962 10.3085C13.2391 10.2695 13.2735 10.2219 13.2969 10.1688C13.3204 10.1157 13.3326 10.0582 13.3326 10.0002C13.3326 9.94211 13.3204 9.88469 13.2969 9.8316C13.2735 9.7785 13.2391 9.7309 13.1962 9.69184Z" fill="white" fillOpacity="0.56"/>
            </svg>
          </button>

          {/* Privacy Policy Button */}
          <button 
            onClick={() => navigate('/privacy-policy')}
            className="flex w-full justify-between items-center"
            style={{ 
              padding: '20px',
              background: '#202020',
              color: '#FFF',
              fontFamily: '"Aeonik TRIAL"',
              fontSize: '16px',
              fontWeight: 500,
              lineHeight: '20px',
              letterSpacing: '-0.2px',
              border: 'none',
              borderRadius: '16px',
              marginBottom: '6px'
            }}
          >
            <span>Privacy Policy</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.1962 9.69184L7.67116 4.33351C7.32533 3.99934 6.66699 4.20184 6.66699 4.64184V15.3585C6.66699 15.7985 7.32533 16.001 7.67116 15.6668L13.1962 10.3085C13.2391 10.2695 13.2735 10.2219 13.2969 10.1688C13.3204 10.1157 13.3326 10.0582 13.3326 10.0002C13.3326 9.94211 13.3204 9.88469 13.2969 9.8316C13.2735 9.7785 13.2391 9.7309 13.1962 9.69184Z" fill="white" fillOpacity="0.56"/>
            </svg>
          </button>
        </div>

        {/* Separator */}
        <div style={{ 
          marginTop: '24px', 
          marginBottom: '24px', 
          width: '100%',
          height: '1px',
          backgroundColor: 'rgba(255, 255, 255, 0.06)'
        }}></div>

        {/* Logout Button */}
        <button 
          onClick={() => logout()}
          disabled={logoutLoading}
          className="flex w-full justify-between items-center"
          style={{ 
            padding: '20px',
            background: '#202020',
            color: '#FE3636',
            fontFamily: '"Aeonik TRIAL"',
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: '20px',
            letterSpacing: '-0.2px',
            border: 'none',
            borderRadius: '16px',
            marginBottom: '6px',
            opacity: logoutLoading ? 0.6 : 1
          }}
        >
          <span>{logoutLoading ? 'Logging out...' : 'Logout'}</span>
        </button>
      </div>
    </div>
  );
};

export default Settings; 